import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import SLAService from '_services/external-kpi-service';

export const fetchExternalKPI = createAsyncThunk(
  'slaReports/fetch',
  async (params, { signal }) => {
    return await SLAService.getExternalKPIs(params, signal);
  }
);

const initialState = {
  data: null,
  status: 'idle',
  error: null,
};

const slaReportsSlice = createSlice({
  name: 'slaReports',
  initialState,
  reducers: {
    resetExternalKPI: (state) => {
      state.data = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExternalKPI.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchExternalKPI.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchExternalKPI.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const selectExternalKPIData = (state) => state.slaReports.data;
export const selectExternalKPIStatus = (state) => state.slaReports.status;
export const selectExternalKPIError = (state) => state.slaReports.error;

export const selectSLAReportStatus = selectExternalKPIStatus;
export const selectSLAReportError = selectExternalKPIError;

export const { resetExternalKPI } = slaReportsSlice.actions;

export default slaReportsSlice.reducer;

